import { t } from "i18next"
import { Modal, Box } from '@mui/material';

import { deleteJob, getJobsList } from "../../../../services/jobService"
import { Typography } from "../../../Typography/typography"
import styles from './EmployerPortalJobDetail.module.css'

export const applicationUI = (applications, navigate, jobDetail, userToken, handleGoBack, setJobs, showDeleteConfirmation, setShowDeleteConfirmation, canNotDeletePopup, setcanNotDeletePopup) => {
    const {
        New = 0,
        Shortlisted = 0,
        Reviewing = 0,
        Interviewing = 0,
        Hired = 0,
        Rejected = 0,
        Undecided = 0
    } = applications?.statusCounts || {};

    const all = New + Shortlisted + Reviewing + Interviewing + Hired + Rejected + Undecided

    const APPLICATIONDATA = [
        { title: t('general.applications.all'), count: all || 0 },
        { title: t('general.applications.new'), count: New || 0 },
        { title: t('general.applications.shortlisted'), count: Shortlisted || 0 },
        { title: t('general.applications.interviewing'), count: Interviewing || 0 },
        { title: t('general.applications.rejected'), count: Rejected || 0 }
    ];

    const handleJobSeekerView = () => { 
        window.open('/jobs/' + jobDetail.slug, '_blank');
    }
    const handleEditJob = () => { navigate(`/employer-portal/${jobDetail.id}/edit`); }

    const handleDeleteClick = () => {
        if (jobDetail.status == 'active') { setcanNotDeletePopup(true) }
        else { setShowDeleteConfirmation(true); }
    }

    const handleConfirmDelete = async () => {
        setShowDeleteConfirmation(false);
        await deleteJob(jobDetail.id, userToken);
        await getJobsList(1, 1000, null, { employer_id: jobDetail.employer_id }, jobDetail.employerDetail.employer_status || jobDetail.jobseeker_status)
            .then((response) => {
                setJobs(response)
                handleGoBack()
            })
            .catch((error) => { console.error('Failed to fetch jobs after retries:', error); });
    }

    const handleCancelDelete = () => {
        setShowDeleteConfirmation(false);
    }
    const handleOkButton = () => {
        setcanNotDeletePopup(false)
    }

    return (
        <div className={styles.applicationWrapper}>
            <Typography title={t('general.applications.title')} weight={'600'} fontSize={16} />
            <div className={styles.applicationData}>
                {APPLICATIONDATA.map((item, index) => {
                    return (
                        <div
                            key={index.toString()}
                            style={{
                                border: "1px solid black", cursor: "pointer", padding: '5px 10px', borderRadius: `5px`,
                                border: '1px solid rgb(82 138 198)'
                            }}
                            onClick={() => navigate('/employer-portal/applicants', { state: { ...item, job_id: [jobDetail.id ]} })}>
                            <Typography title={item.title + ` (${item.count})`}
                                weight={'400'}
                                color={`#434546`}
                                fontSize={14}
                                textTransform={'capitalize'} />
                        </div>
                    )
                })}
            </div>
            <div className={styles.editButtonWrapper} onClick={handleEditJob}>
                {t('general.applications.buttons.editJob')}
            </div>
            <div
                className={`${styles.editButtonWrapper} ${styles.viewAsJobSeekerWrapper}`}
                onClick={handleJobSeekerView}>
                <Typography
                    weight={'500'}
                    fontSize={16}
                    color={'#0464B2'}
                    textAlignCenter={"center"}
                    textTransform={'capitalize'}
                    title={t('general.applications.buttons.viewAsJobSeeker')}
                />
            </div>
            <div
                className={`${styles.editButtonWrapper} ${styles.deleteJob}`}
                onClick={handleDeleteClick}
            >
                {t('general.applications.buttons.deleteJob')}
            </div>

            {/* Delete Confirmation Modal */}
            <Modal
                open={showDeleteConfirmation}
                onClose={handleCancelDelete}
                aria-labelledby="delete-confirmation-modal"
                aria-describedby="delete-confirmation-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    py: '10px',
                    px: '20px',
                    borderRadius: 2,
                }}>
                    <Typography textAlignCenter={'center'} style={{ margin: "10px 0px" }} fontSize={26} title={t('general.UI.confirmation')} />
                    <Typography id="delete-confirmation-description" style={{ margin: "0px 0px 10px 0px" }} title={t('general.UI.deleteJobConfirmation')} />
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', margin: "10px 0px" }}>
                        <button
                            onClick={handleCancelDelete}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                background: 'white',
                                cursor: 'pointer'
                            }}
                        >
                            {t('general.UI.cancel')}
                        </button>
                        <button
                            onClick={handleConfirmDelete}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '4px',
                                border: 'none',
                                background: '#d32f2f',
                                color: 'white',
                                cursor: 'pointer'
                            }}
                        >
                            {t('general.UI.delete')}
                        </button>
                    </div>
                </Box>
            </Modal>
            <Modal
                open={canNotDeletePopup}
                onClose={handleOkButton}
                aria-labelledby="delete-confirmation-modal"
                aria-describedby="delete-confirmation-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    py: '10px',
                    px: '20px',
                    borderRadius: 2,
                }}>
                    <Typography
                        textAlignCenter={'center'}
                        style={{ margin: "10px 0px" }}
                        title={t('general.UI.canNotDeleteMsg')} />
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', margin: "10px 0px" }}>
                        <button
                            onClick={handleOkButton}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '4px',
                                border: '1px solid white',
                                // background: 'white',
                                cursor: 'pointer',
                                color: 'white',
                                background: "#0464B2",
                            }}
                        >
                            {t('general.UI.cancel')}
                        </button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}